import { useCallback } from 'react';
import {
  connectPrinter,
  disconnectPrinter,
  getPrinter,
} from 'shared/printerManager';

export const usePrintManager = () => {
  const isConnected = useCallback(() => {
    return !!getPrinter();
  }, []);

  const connect = useCallback(
    async (ipAddress, setConnectionStatus, setIsVisible) => {
      try {
        await connectPrinter(ipAddress, setConnectionStatus, setIsVisible);
      } catch (err) {
        console.error('Failed to connect to printer:', err);
        throw err;
      }
    },
    []
  );

  return {
    connect,
    disconnect: disconnectPrinter,
    isConnected,
  };
};
